<template>
  <div class="live-room">
    <ul class="live-link" v-if="list.length != 0">
      <!-- 返回的 active 是一个字符串，就离谱-->
      <li v-for="(item, key) in list" :key="key" :class="[item.active !== 'false' ? 'highlight' : 'grizzly']"
        @click="toggleActive(key)">
        {{ item.key }}
      </li>
    </ul>

    <div class="cheer-for">
      <!-- 赛事奖金  -->
      <!-- <div
        class="prize-money"
        :style="{ display: 'block' }"
        @click="handleShowPrizeMoney"
      ></div> -->
      <div class="cheer-btn">
        <button @click="openModal" class="cheer" :class="{ anime: !isInterdict }"></button>
        <TipDot v-show="clickedToday" placement="cheer"></TipDot>
      </div>
      <!-- 直播竞猜按钮 -->
      <div class="quiz-entrance" :style="{ display: 'block' }" @click="handleClickQuiz">
        <tip-dot v-show="showLingqu.quizHots.liveReal" placement="quiz"></tip-dot>
      </div>

      <div class="amount-entrance" @click="handleClickGetAmount" style="display: block">
        <tip-dot v-show="showLingqu.taskHots.liveDaily" placement="liveDaily"></tip-dot>
      </div>

      <div v-if="showModal" class="modal">
        <div class="modal-warp">
          <div class="modal-content">
            <template v-if="isInterdict">
              <Interdict class="interdict" tip="敬请期待" />
            </template>
            <!-- 弹窗内容 -->
            <template v-else>
              <div class="text-tip">
                <span>可点击下方战队图标</span>,去战队主页为战队送礼加油！
              </div>
              <ul class="clan-list" v-if="cheerForList.length != 0">
                <li class="clan" v-for="(item, key) in cheerForList" :key="key" @click="openPresent(item)">
                  <div class="icon">
                    <div
                      class="head"
                      :style="{'background-image': `url(${item?.avatar})`}"
                    ></div>
                    <div class="frame"></div>
                  </div>
                  <div class="hot">
                    <div class="clan-name">
                      <div class="label-box">
                        <div class="label-shadow">{{ item?.name }}</div>
                        <div class="label-text">{{ item?.name }}</div>
                      </div>
                    </div>
                    <div class="clan-hot">
                      <i></i>
                      <div class="clan-count">
                        <!-- {{
                        item.popularity >= 10000
                          ? (item.popularity / 10000).toFixed(2) + '万'
                          : item.popularity || 0
                      }} -->
                        {{ countShow(item.popularity) }}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </template>
            <button @click="closeModal" class="close-modal"></button>
          </div>
        </div>
      </div>
    </div>
    <GivePresent ref="present"></GivePresent>
    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as api from '@/service/index'
import GivePresent from '@/views/live/givePresent.vue'
import TipDot from '@/components/tip-dot.vue'
import Prompt from '@/components/prompt'
import Interdict from "@/components/interdict";


export default {
  components: {
    GivePresent,
    TipDot,
    Prompt,
    Interdict,
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      showPresent: false,
      showModal: false,
      giftList: [],
      cheerForList: [],
      clickedToday: true, //控制红点展示
      serverDate: '', // 用于存储服务端返回的时间
    }
  },
  watch: {},
  computed: {
    ...mapState(['amount', 'token', 'showLingqu', 'isInterdict'])
  },
  created() {
    this.fetchServerTime()
    // 强刷一次
    // TODO 二阶段开放
    if (!this.token) return;
    this.fetchGetGiftList({ token: this.token, force: true })
  },
  mounted() {
    // 进入送礼弹窗
    let gift_giving = this.$route.query.is_send;
    if (gift_giving) {
      this.openModal()
    }
  },
  methods: {
    ...mapActions(['reqUserInfo']),
    toggleActive(key) {
      if (this.list[key].active === 'true') {
        return
      }
      this.list.forEach((item) => {
        item.active = 'false'
      })
      const item = this.list[key]
      item.active = 'true'
      this.$emit('updatelivelink', item.value)
    },
    openModal() {
      // 获取助威列表
      if (!this.token) return;

      // 不显示送礼模块时，拦截不必要的请求
      if(!this.isInterdict) {
        this.cheerForListData(this.token)
        // 记录每天第一次
        this.fetchServerTime()
      }
      this.showModal = true
    },
    async fetchServerTime() {
      try {
        const response = await api.reqcurrentTime(); // 假设这个方法能请求到服务器时间
        if (response.status === 200) {
          this.serverDate = new Date(response.data); // 将服务端时间转换为 Date 对象
          const date = new Date(response.data);
          this.serverDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
          this.checkIfClickedToday()
        }
      } catch (error) {
        console.error('获取服务器时间失败', error);
      }
    },


    checkIfClickedToday() {
      const savedDate = localStorage.getItem('buttonClickDate'); // 从 localStorage 中获取保存的日期
      if (savedDate && savedDate == this.serverDate) {
        // console.log('今天点击过了');
        // savedDate == this.serverDate ? this.clickedToday = true : this.clickedToday = false
        // 说明今天点击了
        localStorage.setItem('buttonClickDate', this.serverDate);
        this.clickedToday = false
      } else {
        this.clickedToday = true
        localStorage.setItem('buttonClickDate', this.serverDate);

      }

    },
    closeModal() {
      this.showModal = false
    },
    async openPresent(item) {
      if (!this.token) return;
      this.$refs.present.openPresent('', '')
      this.reqUserInfo(true)
      const res = await this.fetchGetGiftList({ token: this.token, force: false })
      if (res.length) {
        this.$refs.present.openPresent(item, res)
      }
    },

    handleGiftSent() {
      // this.$emit('giftSent')
      this.cheerForListData()
    },

    // 获取礼物内容
    async fetchGetGiftList(data) {
      try {
        const req = await api.reqGiftList(data)
        if (req.status === 200) {
          // console.log('123',req.data)
          return req.data
        }
      } catch (err) {
        console.log(err)
      }
    },
    // Fisher-Yates 洗牌算法 (推荐)
    shuffleArray(array) {
      const result = [...array];
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
      }
      return result;
    },
    // 获取助威列表
    async cheerForListData() {
      if (!this.token) return;
      try {
        let response = await api.getGiftTeamList(this.token)
        const { data } = response
        this.cheerForList = this.shuffleArray(data)
      } catch (err) {
        console.log(err)
      }
    },
    // handleGetAmount() {
    //   this.$refs.getAmount.getAmount()
    // },
    countShow(hot) {
      if (hot) {
        if (hot < 10000) {
          return hot
        } else if (10000 <= hot && hot < 99999999) {
          return (((hot / 10000) * 100) / 100).toFixed(2) + '万'
        } else {
          return 9999 + '万+'
        }
      } else {
        return 0
      }
    },
    handleClickGetAmount() {
      // this.handleGetAmount()
      this.$emit('openIncentives')
    },
    handleClickQuiz() {
      // this.handleGetAmount()
      // 判断竞猜币是都上限
      // console.log('this.amo',this.amount)
      if (this.amount.quizRemainNum >= 99999) {
        // this.$refs.prompt.setMsg('竞猜币已达上限,无法继续竞猜')
        this.$parent.handleBettingLimit()
        return
      }
      this.$emit('tryQuiz')
    },
    handleShowPrizeMoney() {
      this.$emit('openPrizeMoney')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/live/live-room';
</style>